var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCity = function SvgCity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.64a2.672 2.672 0 1 0 0 5.344 2.672 2.672 0 0 0 0-5.343Zm0 4.5a1.828 1.828 0 1 1 0-3.656 1.828 1.828 0 0 1 0 3.657Zm0-7.874a6.054 6.054 0 0 0-6.047 6.046c0 2.174 1.008 4.482 2.916 6.676a17.74 17.74 0 0 0 2.89 2.672.421.421 0 0 0 .483 0 17.741 17.741 0 0 0 2.889-2.672c1.908-2.194 2.916-4.5 2.916-6.675A6.054 6.054 0 0 0 9 1.266Zm0 14.52c-1.055-.814-5.203-4.281-5.203-8.473a5.203 5.203 0 1 1 10.406 0c0 4.192-4.148 7.659-5.203 8.473Z",
    fill: "#010101"
  })));
};
export default SvgCity;